import { render, staticRenderFns } from "./PromotionBarcode.vue?vue&type=template&id=48baee2c&scoped=true"
import script from "./PromotionBarcode.vue?vue&type=script&lang=js"
export * from "./PromotionBarcode.vue?vue&type=script&lang=js"
import style0 from "./PromotionBarcode.vue?vue&type=style&index=0&id=48baee2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48baee2c",
  null
  
)

export default component.exports